var Enable_pincode = true;

if (Enable_pincode) {

    const pinField = document.getElementById("pincode_1");
    const pin_regex = /^[1-9][0-9]{5}$/;

    $('#pincode_1').keyup(function () {
        if (/\D/g.test(this.value)) {
            this.value = this.value.replace(/\D/g, '');
        }

        const val = this.value.trim();

        if (val.length < 6 || !pin_regex.test(val)) {
            $('#responsemessage').text('Please enter valid Pincode')
                .removeClass('success').addClass('error');
            return;
        }

        // API Call
        pincodeValidation(val);
    });

    function pincodeValidation(pincode) {
        const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;

        $.ajax({
            url: apiUrl,
            method: "GET",
            dataType: "json",
            success: function (response) {
                if (
                    response.success &&
                    response.data?.data?.available_courier_companies?.length > 0
                ) {
                    // === IMPORTANT CHANGE HERE ===
                    let estDays = 2;   // Force 2 days (jaise pehle code mein tha)

                    // Agar API se value lena ho toh neeche wali line uncomment kar do:
                    // const firstCourier = response.data.data.available_courier_companies[0];
                    // estDays = parseInt(firstCourier.estimated_delivery_days || 2, 10);

                    localStorage.setItem("ExistPincode", pincode);
                    localStorage.setItem("DeliveryDays", estDays);

                    getDelivery(estDays);
                } else {
                    showError("Delivery pincode not serviceable.");
                }
            },
            error: function () {
                showError("Error fetching delivery info.");
            }
        });
    }

    function showError(message) {
        $('#responsemessage').html(`<span class="errorMsg">${message}</span>`)
            .removeClass('success').addClass('error');
    }

    function getDelivery(delivery_day) {
        const next_dt = new Date();
        next_dt.setDate(next_dt.getDate() + delivery_day);

        const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

        const day_Name   = dayNames[next_dt.getDay()];
        const month_Name = monthNames[next_dt.getMonth()];
        const date_Name  = next_dt.getDate();

        $('#responsemessage').html(`
            <span class="span2">
                <u>FREE delivery: </u>
                <b>${day_Name}, ${month_Name} ${date_Name}</b>
            </span>
            <span class="span1">Free delivery</span>
        `).removeClass('error').addClass('success');
    }

    // Page Load - Existing Data
    const Existing_pin = localStorage.getItem('ExistPincode');
    const Existing_days = parseInt(localStorage.getItem('DeliveryDays'));

    if (Existing_pin) $('#pincode_1').val(Existing_pin);
    if (!isNaN(Existing_days)) getDelivery(Existing_days);
}